import styled from 'styled-components'
interface Listprops {
  children: JSX.Element | JSX.Element[] | string
  background: string
  style?: React.CSSProperties
}
export const CardList = (props: Listprops) => {
  const { children, background, style } = props
  return (
    <TaskList background={background} style={style}>
      <div className="task-item">{children}</div>
    </TaskList>
  )
}
interface TaskListProps {
  background: string
}
const TaskList = styled.div<TaskListProps>`
  list-style: none;
  height: 80px;
  border-radius: 8px;
  position: relative;
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-end;
  .task-item {
    position: relative;
    width: calc(100% - 3px);
    height: 100%;
    background-color: #f8f9fb;
    border-radius: 8px;
    display: flex;
    padding: 20px;
    align-items: center;
  }
`
